import displayValues from '../../../../assets/displayValues.json';
import { thousandSeparated } from 'shared/util/formatting';

import type { Hotel } from '@/interfaces';
import { GuestRatingSquare } from '@/components/guestRatingSquare/GuestRatingSquare';

export type SearchResultItemGuestRatingProps = Pick<Hotel, 'guestRating' | 'numberOfReviews'> & {
    className?: string;
};

export const SearchResultItemGuestRating = ({ guestRating, numberOfReviews, className = '' }: SearchResultItemGuestRatingProps) =>
    guestRating ? (
        <div className={`flex flex-align-center ${className}`}>
            <div>
                <GuestRatingSquare title="totalt" guestRating={guestRating} />
            </div>
            <div data-testid="ratingDetails" className="u-ml4 u-d1">
                {displayValues.guestRatingSentiments[Math.floor(guestRating)]}
                {numberOfReviews && numberOfReviews > 0 ? ` (${thousandSeparated(numberOfReviews)})` : ''}
            </div>
        </div>
    ) : null;
